<template>
  <div class="video-wrapper" :class="[design]">
    <img class="desktop-img" :src="imgSrc" alt="Video player" />
    <img
      class="mobile-img"
      src="/static/images/cases/shared/videobgmobile2x.png"
      alt="Video player"
    />
    <div class="tablet">
      <VideoPlayer :source="sourceDesktop" />
    </div>
    <div class="phone">
      <VideoPlayer :source="sourceMobile" />
    </div>
  </div>
</template>
<script>
import VideoPlayer from "@/components/general/VideoPlayer";
export default {
  name: "VideoHolder",
  components: { VideoPlayer },
  props: {
    sourceMobile: {
      type: String,
      required: true
    },
    sourceDesktop: {
      type: String,
      required: true
    },
    design: {
      type: String,
      default() {
        return "a";
      }
    }
  },
  computed: {
    imgSrc() {
      if (this.design === "b") {
        return "/static/images/cases/shared/videobgB2x.png";
      }
      return "/static/images/cases/shared/videobg2x.png";
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/typography";

.video-wrapper {
  position: relative;
  max-width: 100%;
  img {
    max-width: 100%;
    z-index: 2;
  }
  .tablet {
    position: absolute;
    width: 39.8%;
    height: 65.7%;
    top: 28.5%;
    left: 17.15%;
    z-index: 1;
  }
  .phone {
    position: absolute;
    width: 11.8%;
    height: 57%;
    top: 37.4%;
    left: 71.6%;
    z-index: 1;
  }
  .mobile-img {
    display: none;
  }

  &.b {
    .tablet {
      width: 51.9%;
      height: 77.6%;
      top: 7%;
      left: 29.5%;
    }
    .phone {
      width: 9.7%;
      height: 48.3%;
      top: 46.6%;
      left: 18.5%;
    }
  }
}

@media (max-width: $mobile) {
  .video-wrapper,
  .video-wrapper.b {
    .desktop-img {
      display: none;
    }
    .mobile-img {
      display: block;
    }
    .tablet {
      display: none;
    }
    .phone {
      width: 49.6%;
      height: 86%;
      top: 14.9%;
      left: 25.5%;
    }
  }
}
</style>
